/* file description */
import type { UseValidateSubmitForm } from './type';

export const useValidateSubmitForm: UseValidateSubmitForm = ({
  queryFormRef,
  saveRequest,
}) => {
  return {
    onSubmit: async () => {
      await queryFormRef.current!.validateFields();
      const res = await saveRequest(queryFormRef.current!.getFieldsValue());
      return res;
    },
  };
};

